import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import FooterCrud from '../footer/FooterCrud';
import ModalAlerta from '../modal/ModalAlerta';
import Preload from '../preload/Preload';
import PreloadContent from '../preload/PreloadContent';
import Sucesso from '../alert/Sucesso';
import Table from '../table/Table';
import Pagination from '../pagination/Pagination';

import AcaoEnum from '../../../helper/enumerador/AcaoEnum';

import './Content.css';

class ContentPesquisa extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.onRemover = this.onRemover.bind(this);

        this.state = {
            preload: false,

            preloadContent: false,   
            
            preloadPagination: false,

            sucesso: {
                message: '',
                code: 0
            },

            erro: {
                message: '',
                code: 0
            },

            id: 0,

            body: [],
            
            page: 1
        }         
        
        this.state.filterApply = this.props.filter;
    }                 

    show() {
        if(this.state.preloadContent || this.props.preload) 
            return ;

        return (
            <Fragment>
                <Sucesso 
                    exibir={this.state.sucesso.code !== 0} 
                    texto={this.state.sucesso.message}
                    timeOut={5}
                    onTimeOut={() => this.setState({sucesso: this.finalizaErro(this.state.sucesso)})}
                />

                <main>
                    <div className="col-md-12
                                    col-sm-12
                                    col-lg-12
                                    col-xs-12">
                        <h1 className="mt-4 mb-4">
                            {this.props.title}
                        </h1>    
                    </div>                   
                                         
                    <div className={"container-fluid container-custom " + (this.props.callBack.pagination.length > 1 ? (this.state.body.length > 0 ? "pagination-container" : "") : "")}>                        
                        {
                            !this.state.preloadPagination &&                        
                            <Table
                                ref={ref => this.table = ref}
                                head={this.props.head}
                                body={this.state.body}
                                filter={this.state.filterApply}
                                filterService={this.props.searchService}
                                defaultFocoFilter={this.props.defaultFocoFilter}
                                messageRemover={this.props.messageRemover}
                                
                                cadastro={this.props.cadastro}
                                editar={ this.props.editar }
                                view={this.props.view}                                
                                remover={ this.props.remover }
                                filtered={ this.props.filtered }
                                actions={ this.props.actions }
                                
                                link={ this.props.link }

                                onRemover={this.onRemover}                            
                                onCallbackFilter={(filter, resposta, erro) => {this.setState({filterApply: filter, page: 1}); this.props.onCallbackFilter(resposta, erro)}}                            

                                route={(route) => this.props.route(route)}    

                                component={ this.props.component }
                            />                                               
                        }

                        <PreloadContent 
                            height={'60vh'}
                            show={this.state.preloadPagination} 
                        />
                    </div>                                        
                  
                    {
                        this.state.body.length > 0 && this.props.callBack.pagination.length > 1 &&                    
                        <Pagination
                            md={12}
                            xs={12}
                            sm={12}
                            lg={12}
                            page={this.state.page}
                            filter={this.state.filterApply}
                            filterService={this.props.searchService}
                            pagination={this.props.callBack.pagination} 
                            
                            onCallback={(item, resposta, erro) => {this.setState({page: item}); this.props.onCallbackFilter(resposta, erro)}}  
                            onPreload={(value) => this.setState({preloadPagination: value})}                          
                        />
                    }
                </main>                

                <FooterCrud 
                    history={this.props.history}
                    
                    route={(route) => this.props.route(route)}
                />
            </Fragment>
        )
    }

    fechar() {
        if(this.props.fecharModal !== undefined)
            this.props.fecharModal();
    }

    add(item, i) {
        this.table.fecharCadastro();
        const body = this.state.body;

        if(i === undefined)  {
            body.push(item);
            this.setState({body: body});

            return;
        }

        body[i] = item;
        this.setState({body: body});
    }    

    onRemover(item , i) {
        this.setState({preload: true});

        this.props.onRemover((item.id === undefined ? item.uuid : item.id), i);
    } 

    componentDidMount() {
        this.setState({preloadContent: true});

        this.props.onLoad();
    }

    componentDidUpdate(prevProps) {      
        const prev = prevProps.callBack;        
 
        if((prev.id !== this.state.id)) {
            const callBack = this.props.callBack;
            
            switch(callBack.acao) {                
                case AcaoEnum.LOAD: 
                    this.setState({
                        id: prev.id,
                        preloadContent: false,                        
                        body: callBack.body,                        
                        mensagem: callBack.mensagem
                    });

                    break;
                case AcaoEnum.REMOVER: 
                    const body = this.state.body;
                
                    body.splice(callBack.indice, 1);
                
                    this.setState({
                        id: prev.id,
                        preload: false,
                        body: body,    
                        sucesso: callBack.mensagem                     
                    });

                    break;
                case AcaoEnum.ERRO:                    
                    this.setState({
                        id: prev.id,
                        preload: false,                        
                        preloadContent: false,
                        erro: callBack.mensagem
                    });

                    break;
                default:
                    break;
            }                        
        }
    }

    render() {
        return (
            <Fragment>
                <ModalAlerta
                    show={this.state.erro.code !== 0}
                    texto={this.state.erro.message}
                    fechar={() => this.setState({erro: this.finalizaErro(this.state.erro)})}
                />

                <Preload show={this.state.preload} />

                <PreloadContent show={this.state.preloadContent || this.props.preload} />
                                
                {this.show()}
            </Fragment>
        )
    }
}

ContentPesquisa.defaultProps = {    
    title: '',
    cadastro: false,
    editar: false,
    callBack: {
        body: [],
        mensagem: {
            message: '',
            code: 0
        }
    },    
    page: 1    
}

export default ContentPesquisa;